import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import styles from "./Contact.module.css";
import { postMsg } from "../../Firebase/FirebaseFetch";
// import "."
function Contact(props) {
  const submitHandler = async (e) => {
    e.preventDefault();
    let btn = document.getElementById("btn");
    let btnText = document.getElementById("btnText");

    const data = {
      name: e.target.name.value,
      email: e.target.email.value,
      message: e.target.message.value,
    };
    await postMsg(data).then(() => {
      e.target.name.value = "";
      e.target.email.value = "";
      e.target.message.value = "";
      btn.classList.add(`${styles.active}`);
      btnText.innerHTML = "Thanks";
      setTimeout(() => {
        btn.classList.remove(`${styles.active}`);
        btnText.innerHTML = "Submit";
      }, 5000);
    });
  };

  return (
    <Container className={styles.contactContainer}>
      <div className={`${styles.card} animate__animated animate__fadeInLeft`}>
        <Row className="text-white">
          <Col sm={12} md={6} lg={6}>
            <div className={styles.contactLogo}>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="92.578"
                height="58.736"
                viewBox="0 0 92.578 58.736"
              >
                <motion.path
                  initial={{
                    opacity: 1,
                    pathLength: 2,
                    offsetPath: 0,
                  }}
                  animate={{
                    opacity: 1,
                    pathLength: 0,
                    offsetPath: 1,
                  }}
                  transition={{ duration: 2, repeat: Infinity, delay: 0 }}
                  id="Path_8"
                  data-name="Path 8"
                  d="M1082.78,843.793l-45.9,28.868-44.485-28.868h90.389v57.736H992.391V843.793"
                  transform="translate(-990.702 -843.293)"
                  fill="none"
                  stroke="#707070"
                  stroke-width="1"
                />
              </svg> */}
              <motion.svg
                initial={{ x: 0, y: 0, scale: 1, opacity: 1 }}
                animate={{
                  x: [-150, 0, 0, 0, 0, 150],
                  y: [200, 0, 0, 0, 0, -200],
                  scale: [0.2, 1.2, 1.2, 1.2, 1.2, 0.2],
                  opacity: [0, 1, 1, 1, 1, 0],
                }}
                transition={{
                  // delayChildren: 3,
                  duration: 12,
                  delay: 0,
                  repeat: Infinity,
                  repeatType: "loop",
                  // repeatDelay: 0,
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="106.211"
                height="100.338"
                viewBox="0 0 106.211 100.338"
              >
                <g
                  id="Group_1"
                  data-name="Group 1"
                  transform="translate(-768.017 -717.345)"
                >
                  <motion.path
                    initial={{
                      pathLength: 1,
                    }}
                    animate={{
                      pathLength: [1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
                    }}
                    transition={{
                      duration: 12,
                      repeat: Infinity,
                      // repeatType: "reverse",
                    }}
                    id="Path_8"
                    data-name="Path 8"
                    d="M1082.78,843.793l-45.9,28.868-44.485-28.868h90.389v57.736H992.391V843.793"
                    transform="translate(-212 -123)"
                    fill="none"
                    stroke="#f82f6f"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                  />
                  <motion.path
                    initial={{
                      pathLength: 0,
                    }}
                    animate={{
                      pathLength: [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1],
                    }}
                    transition={{
                      duration: 12,
                      repeat: Infinity,
                    }}
                    id="Path_9"
                    data-name="Path 9"
                    d="M1271.277,870.562l-100.264,30.21,41.889,19.366,13.941,44.815,44.434-94.391L1213.065,920"
                    transform="translate(-400.497 -149.77)"
                    fill="none"
                    stroke="#f82f6f"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                  />
                </g>
              </motion.svg>

              {/* <img src={contactImage} alt="contact" /> */}
            </div>
          </Col>
          <Col sm={12} md={6} lg={6}>
            <Container className="text-center">
              <form onSubmit={submitHandler}>
                <Row>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Name"
                    required
                  />
                </Row>
                <Row>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </Row>
                <Row>
                  <textarea
                    id="message"
                    type="text"
                    name="message"
                    placeholder="Message"
                    rows={6}
                    cols={52}
                    required
                  />
                </Row>
                <button id="btn">
                  <p id="btnText">Submit</p>
                  <div className={styles.checked}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                      <path
                        fill="transparent"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                      ></path>
                    </svg>
                  </div>
                </button>
              </form>
            </Container>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Contact;
